import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export let AllPagesThunk = createAsyncThunk(
	"pages/AllPagesThunk",
	async (_, ThunkApi) => {
		let { rejectWithValue } = ThunkApi;
		try {
			let url = `api/admin/pages`;

			let res = await axios.get(url);

			return res.data;
		} catch (error) {
			return rejectWithValue(error.response.data);
		}
	}
);
